import { MoneyMapFilterState, MoneyMapVisual } from '@fruitful/money-map';
import { type MoneyMapWidgetProps } from '@fruitful/types';
import React, { useEffect, useState } from 'react';
import { H5Emphasized, YStack } from 'smoothie';

interface MoneyMapWidgetComponentProps extends MoneyMapWidgetProps {
    /** Called when the member narrows the visual to a single category. */
    onFilterChange?: (filter: MoneyMapFilterState) => void;
}

export const MoneyMapWidget = ({
    title,
    incomeTotalCents,
    billsTotalCents,
    spendTotalCents,
    goalsTotalCents,
    isIncomeSplitEligible = true,
    onFilterChange,
}: MoneyMapWidgetComponentProps) => {
    // MoneyMapVisual is a controlled component; the chat has no persistent
    // filter UI, so the wrapper owns the filter state (defaults to ALL).
    const [filter, setFilter] = useState(MoneyMapFilterState.ALL);

    useEffect(() => {
        if (filter !== MoneyMapFilterState.ALL) {
            onFilterChange?.(filter);
        }
    }, [filter]);

    return (
        <YStack width="100%" gap={12}>
            {title != null && title !== '' && (
                <H5Emphasized color="$black">{title}</H5Emphasized>
            )}
            <MoneyMapVisual
                incomeTotalCents={incomeTotalCents}
                billsTotalCents={billsTotalCents}
                spendTotalCents={spendTotalCents}
                goalsTotalCents={goalsTotalCents}
                filter={filter}
                setFilter={setFilter}
                isIncomeSplitEligible={isIncomeSplitEligible}
            />
        </YStack>
    );
};
